import Ajax from '../js/common/ajax'

export default {
  recognizeShopOrder(params = {}) {
    return Ajax.post('/upload/smart-recognize-shop-order', params)
  },

  recognizeStripe(params = {}) {
    return Ajax.post('/upload/smart-recognize-stripe', params)
  },

  recognizeStatement(params = {}) {
    return Ajax.post('/upload/smart-recognize-stripe', params)
  },

  list(params = {}) {
    return Ajax.get('/original-vouchers', { params })
  },

  detail(id) {
    return Ajax.get(`/original-vouchers/${id}`)
  },

  submitFeedback(voucherId, params = {}) {
    return Ajax.post(`/original-vouchers/${voucherId}/feedback`, params)
  }
}
